import { LinearProgress } from '@mui/material';
import * as React from 'react';

export class CanvasPlaceholder {
    render() {
        return <LinearProgress className="iw-progress" />
    }
}
